module.exports = __webpack_public_path__ + "media/packs/images/details/watchers-8d6b67fed381ec741e11c849629317ea.svg";